const filterInputNumber = (inputNumberNodes) =>{
    for (let i = 0; i < inputNumberNodes.length; i++) {
        const inputNumberNode = inputNumberNodes[i];
        const min = inputNumberNode.getAttribute('min');

        if (min && min === '0') {
            inputNumberNode.addEventListener('input', function () {
                this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null;
            })
        }
    }
}

const realpressValidateForm = () => {
    const inputNumberNodes = document.querySelectorAll('.realpress-input-content input[type="number"]');
    if (!inputNumberNodes) {
        return;
    }

    filterInputNumber(inputNumberNodes);
};

export {filterInputNumber}
export default realpressValidateForm;
